import { useQuery } from '@tanstack/react-query';
import { InventoryHistoryResponse } from '../types/inventory';
import { fetchInventoryHistory } from '../api/inventory';

interface UseItemHistoryParams {
  itemId?: string;
  page?: number;
  pageSize?: number;
}

export function useItemHistory({ itemId, page = 1, pageSize = 10 }: UseItemHistoryParams) {
  return useQuery<InventoryHistoryResponse>({
    queryKey: ['itemHistory', itemId, page, pageSize],
    queryFn: async () => {
      if (!itemId) throw new Error('Item ID is required');
      return fetchInventoryHistory({ itemId, page, pageSize });
    },
    enabled: !!itemId,
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
  });
}
